export default __webpack_public_path__ + "images/YB.a32dd7a.png";